import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHandlerService } from '../../../../core/services/api-handler/api-handler.service';
import { ApiUrls } from '../../../../core/utilities/APIUris';
import { OrganizationDetails } from '../../../../core/models/organization.model';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private apiHandlerService = inject(ApiHandlerService);

  getLanguageList(): Observable<OrganizationDetails>{
    return this.apiHandlerService.doGet(ApiUrls.getLanguages, false, false);
  }
  getLanguageDetails(language: string | null): Observable<OrganizationDetails>{
    return this.apiHandlerService.doGet(`${ApiUrls.getLanguages}/${language}`, false, false);
  }
  getLanguageLabels(): Observable<OrganizationDetails>{
    return this.apiHandlerService.doGet(`${ApiUrls.getLanguages}/labels`, false, false);
  }
  setLanguageLabels(language: string, labels: any): Observable<OrganizationDetails>{
  return this.apiHandlerService.doPut(`${ApiUrls.getLanguages}/${language}`, { labels }, false, false);
  }
}